import { ReactNode } from 'react'
import { useNavigate } from 'react-router-dom'
import { faArrowLeft } from '@fortawesome/pro-regular-svg-icons'
import { Icon, Text, Button, Separator } from '@/ui'
import { TypographyStyles } from '@/styles'
import { useIsDeviceWidth, DeviceWidth } from '@/utils/deviceWidthHelpers'

export const PageHeader = ({
  header,
  isMultiStep,
  extraContent,
  backControl,
  divider = true,
  className,
  size,
}: {
  header: ReactNode
  isMultiStep?: boolean
  extraContent?: ReactNode
  backControl?: {
    link: string | -1
    text: string
  }
  divider?: boolean
  className?: string
  size?: TypographyStyles
}) => {
  const navigate = useNavigate()
  const isMobile = useIsDeviceWidth(DeviceWidth.mobile)
  let defaultSize = TypographyStyles.H1

  if (isMultiStep) {
    defaultSize = TypographyStyles.H3
  } else if (isMobile) {
    defaultSize = TypographyStyles.H2
  }

  const leftMarginStyle = isMobile ? 'ml-4' : ''
  return (
    <div className={`flex flex-col gap-2 ${className} w-full mb-2`}>
      {backControl && (
        <div className="flex flex-col">
          <div className="short" />
          <div className={`flex ${leftMarginStyle}`}>
            {/* @ts-expect-error -- -1 is a valid parameter that navigates to the last page on the stack */}
            <Button onClick={() => navigate(backControl.link)} variant="link">
              <Icon icon={faArrowLeft} className="mr-4" />
              {backControl.text}
            </Button>
          </div>
          {divider && <Separator />}
        </div>
      )}
      <div
        className={`flex ${isMobile ? 'flex-col' : 'flex-row items-center'} justify-between`}
      >
        <Text variant={size ?? defaultSize}>{header}</Text>
        <div
          className={`flex items-end max-w-[250px] ${isMobile ? 'pr-5 mt-2' : ''}`}
        >
          {extraContent}
        </div>
      </div>
    </div>
  )
}
